var ownerCount=1;
var nextAvailableOwnerNumber = [];

$("body").on("click", "#rowAdder", function () {
    
    ownerNumber = 0;
    if (nextAvailableOwnerNumber.length > 0) {
        var ownerNumber = nextAvailableOwnerNumber.shift();
        // alert("Using old value: " + ownerNumber)
    } else {
        // alert("Using new value")
        ownerCount += 1;
        var ownerNumber = ownerCount;
    }
    // alert("Adding Row " + ownerCount);

    newRowAdd =
        '<div class="row">' +
        '    <div id="ownerIndividual' + ownerNumber + '">' +
        '        <div class="col-sm-4 col-sm-offset-1">' +
        '        <div class="form-group label-floating">' +
        '            <label class="control-label">Owner ' + ownerNumber + ' First Name</label>' +
        '            <input name="o' + ownerNumber + '_fname" type="text" class="form-control  " >' +
        '            </div>' +
        '        </div>' +
        '        <div class="col-sm-4">' +
        '            <div class="form-group label-floating">' +
        '                <label class="control-label">Owner ' + ownerNumber + ' Last Name</label>' +
        '                <input name="o' + ownerNumber + '_lname" type="text" class="form-control  " >' +
        '            </div>' +
        '        </div>' +
        '    </div>' +
        '    <div id="ownerCompany' + ownerNumber + '" style="display: none;">' +
        '        <div class="col-sm-8 col-sm-offset-1">' +
        '        <div class="form-group label-floating">' +
        '            <label class="control-label">Owner ' + ownerNumber + ' - Company Name</label>' +
        '            <input name="o' + ownerNumber + '_companyname" type="text" class="form-control  " >' +
        '            </div>' +
        '        </div>' +
        '    </div>' +
        '    <div id="ownerTrust' + ownerNumber + '" style="display: none;">' +
        '        <div class="col-sm-8 col-sm-offset-1">' +
        '        <div class="form-group label-floating">' +
        '            <label class="control-label">Owner ' + ownerNumber + ' - Trust Name</label>' +
        '            <input name="o' + ownerNumber + '_trustname" type="text" class="form-control  " >' +
        '            </div>' +
        '        </div>' +
        '    </div>' +
        '    <div id="ownerOther' + ownerNumber + '" style="display: none;">' +
        '        <div class="col-sm-8 col-sm-offset-1">' +
        '        <div class="form-group label-floating">' +
        '            <label class="control-label">Owner ' + ownerNumber + ' - Entity Name</label>' +
        '            <input name="o' + ownerNumber + '_othername" type="text" class="form-control  " >' +
        '            </div>' +
        '        </div>' +
        '    </div>' +
        '    <div class="col-sm-2">' +
        '        <div class="form-group label-floating">' +
        '            <label class="control-label">Owner Type</label>' +
        '            <select name="o' + ownerNumber + '_type" id="ownerType' + ownerNumber + '" type=ownerType ownerCount="' + ownerNumber + '" class="form-control">' +
        '                <option value="Individual" selected> Individual </option>' +
        '                <option value="Company"> Company </option>' +
        '                <option value="Trust"> Trust </option>' +
        '                <option value="Other"> Other </option>' +
        '            </select>' +
        '        </div>' +
        '    </div>' +
        '   <div class="col-sm-1 display-inline-block form-group" >' + 
        '        <a href="javascript:void(0)" name="deleteRow" id="deleteOwner' + ownerNumber + '" ownerCount="' + ownerNumber + '" class="text-danger"><i class="material-icons">delete</i></a>' + 
        '    </div>' +
        '</div>'
	

    $('#ownerinfo').append(newRowAdd);
});

$("body").on("click", "a[name=deleteRow]", function () {
    var ownerNumber = $(this).attr("ownerCount");
    nextAvailableOwnerNumber.push(ownerNumber);
    nextAvailableOwnerNumber.sort();

    // alert("Deleting Row " + ownerNumber);
    $(this).parent().parent().remove();
})

$("body").on("click", "#hasMortgageDiv", function () {
    $("#hasMortgage").prop("checked", function (i, val) {
        if(val) {
            $("#mortgageAmount").show();
        } else {
            $("#mortgageAmount").hide();
            $("input[name='p_mortgage_amount']").val('');
        }
    })
})

$("body").on("click", "#hasLiensDiv", function () {
    $("#hasLiens").prop("checked", function (i, val) {
        if(val) {
            $("#lienAmount").show();
        } else {
            $("#lienAmount").hide();
            $("input[name='p_lien_amount']").val('');
        }
    })
})

$("body").on("click", "#taxesOwedDiv", function () {
    $("#taxesOwed").prop("checked", function (i, val) {
        if(val) {
            $("#taxesOwedAmount").show();
        } else {
            $("#taxesOwedAmount").hide();
            $("input[name='p_taxes_owed']").val('');
        }
    })
})

$("body").on("click", "#isHoaDiv", function () {
    $("#isHoa").prop("checked", function (i, val) {
        if(val) {
            $("#hoaFee").show();
        } else {
            $("#hoaFee").hide();
            $("input[name='p_hoa']").val('');
        }
    })
})

$("body").on("change", "select", function () {
    if(!$(this).attr("ownerCount")){
        return;
    }
    var ownerNumber = $(this).attr("ownerCount");
    var ownerId = "#ownerType" + ownerNumber;

    switch($(ownerId).val()){
        case "Individual":
            $("#ownerIndividual" + ownerNumber).show();
            $("#ownerCompany" + ownerNumber).hide();
            $("#ownerTrust" + ownerNumber).hide();
            $("#ownerOther" + ownerNumber).hide();
        break;
        case "Company":
            $("#ownerIndividual" + ownerNumber).hide();
            $("#ownerCompany" + ownerNumber).show();
            $("#ownerTrust" + ownerNumber).hide();
            $("#ownerOther" + ownerNumber).hide();
        break;
        case "Trust":
            $("#ownerIndividual" + ownerNumber).hide();
            $("#ownerCompany" + ownerNumber).hide();
            $("#ownerTrust" + ownerNumber).show();
            $("#ownerOther" + ownerNumber).hide();
        break;
        case "Other":
            $("#ownerIndividual" + ownerNumber).hide();
            $("#ownerCompany" + ownerNumber).hide();
            $("#ownerTrust" + ownerNumber).hide();
            $("#ownerOther" + ownerNumber).show();
        break;
    }
})

$("body").on("click", "#hasRealtorDiv", function () {
    $("#hasRealtor").prop("checked", function (i, val) {
        if(val) {
            $("#realtorInfo").show();
        } else {
            $("#realtorInfo").hide();
            $('input[name="p_agent_name"]').val('');
            $('input[name="p_agent_phone"]').val('');
        }
    })
})

function scrollToAnchor(aid){
    const destination = $("a[name='"+ aid +"']");
    $('html,body').animate({
        scrollTop: destination.offset().top
    },'slow');
}

$(document).on('click', '#wizardNext', function(){
    scrollToAnchor('wizardTop');
});